const jp = {
  email: "メール",
  birth: "生年月日",
  gender: "性別",
  last_name: "姓",
  first_name: "名",
  postal_code: "郵便番号",
  zip: "郵便番号",
  province: "都道府県",
  city: "市区町村",
  address1: "住所",
  address2: "住所（詳細）",
  phone_number: "電話番号",
  search_address: "郵便番号検索",
  save: "保存",
  cancel: "キャンセル",
  edit: "編集",
  delete: "削除",
  subtotal: "小計",
  shipping_fee: "送料",
  discount: "割引",
  total_amount: "お支払い金額",
  refunded_amount: "返金額",
  cancel_order: "注文キャンセル",
  request_return: "返品申請",
  tracking_number: "追跡番号",
  payment_method: "お支払い方法",
  male: "男性",
  female: "女性",
  "non-binary": "ノンバイナリー",
  current_password: "現在のパスワード",
  new_password: "新しいパスワード",
  confirm_new_password: "パスワード確認",
  view_detail: "詳細を見る",
  confirm: "確認",
  submit: "送信",
  deactivate: "退会",
  password: "パスワード",
  notification: "通知",
  gift: "ノベルティ",
  change: "変更",
  popup_close: "今日一日表示しない",
  return_shipping: "返品送料",
  order_status: {
    title: "注文状況",
    refunded: "払い戻し完了",
    canceled: "キャンセル済み",
    partially: "部分払い戻し済み",
    completed: "決済完了",
    return: "返品受付済み",
    return_approved: "返品承認済み",
    shipped: "配送完了",
    partially_shipped: "一部配送完了",
    scheduled: "予約配送前",
    scheduled_shipped: "予約配送準備中",
    completed_shipped: "予約配送完了",
    preparing: "配送準備中",
    paid: "決済完了",
    pending: "決済確認中",
    prizeCancel: "当選キャンセル",
    drawCancel: "応募キャンセル",
    drawLose: "落選",
    drawWin: "**当選**",
    drawApply: "応募完了",
    gifting_pending: "ギフト受け取り待ち",
    gifting_accepted: "ギフト受け取り完了",
    preorder: "予約発送",
  },
  account: {
    reset_password_email: "パスワードを再設定するためのメールを送信します。",
    login: "ログイン",
    order_history: "注文履歴",
    draw_history: "応募履歴",
    event_history: "イベント参加履歴",
    shipping_address: "お届け先の管理",
    log_out: "ログアウト",
    new_collection: "新商品を見る",
    return_history: "返品履歴",
    personal_information: {
      description:
        "以下のページで会員情報の確認・編集が可能です。<br />注文および配送に関するお問い合わせは、メールまたは右下のチャットサービスからお問い合わせください。",
      accepts_marketing: "マーケティング情報の受信および個人情報の活用同意（選択）",
      update_information: "情報修正",
      employee: "アカウントです。（30% - 50% 常時割引特典）",
    },
    reset_password: {
      description: "パスワードを再設定するためのメールを送信します。",
      request: "メール送信",
      title: "パスワードの再設定",
    },
    deactivation: {
      description: "アカウント削除の申請が受け付けられると、会員情報はすべて削除され、ストアのサービスをご利用いただけなくなります。",
      request: "退会申請",
      ask: "本当に退会しますか？<br />「確認」ボタンを押すと会員退会を進行します。",
      processing: "会員退会処理中",
    },
    social_login: {
      change_password: "現在連携されているソーシャルログインサービスです。",
    },
    membership: {
      discount: "Benefit: {{amount}}",
      coupon: "Discount Code: 月間コード {{amount}}%",
      current: "現在のメンバーシップランク",
      next: "{{month}}月 予定メンバーシップランク",
      view_detail: "メンバーシップ特典の詳細を見る",
      view_membership_detail: "マイメンバーシップを見る",
      my_membership: "メンバーシップ ランク",
      more_info: "メンバーシップ特典の詳細を見る",
      description_new: "{{storeName}} メンバーシップで、特別割引に加え新商品やイベントの情報をいち早くお受け取りください。",
      accumulated_amount1: "過去1年間のご購入累計額は",
      accumulated_amount2: " {{amount}}円です。",
      next_level_new1: "{{next_level}} ランクまで",
      next_level_new2: " あと{{amount}}円です。",
      employee_discount: "社員割引率を適用",
      benefit: {
        title: "{{membership}} 割引特典",
        discount: "{{discount}} 常時割引",
        code: "{{code}} 割引コード 月1回支給",
      },
      amount: {
        current: "現在の累積金額は {{amount}} です。",
        next: "{{membership}} ランクまで残り {{amount}} です。",
      },
      member: {
        discount_code: "",
        benefits: "常時1%割引",
        purchase_amount: "￥0 以上 -\n￥300,000 未満",
      },
      silver: {
        benefits: "常時3%割引\n月間5%割引コード支給",
        purchase_amount: "￥300,000 以上 -\n￥2,000,000 未満",
      },
      gold: {
        benefits: "常時5%割引\n月間7%割引コード支給",
        purchase_amount: "￥2,000,000 以上 -\n￥5,000,000 未満",
      },
      platinum: {
        benefits: "常時7%割引\n月間10%割引コード支給",
        purchase_amount: "￥5,000,000 以上 -\n￥10,000,000 未満",
      },
      vip: {
        benefits: "常時10%割引\n月間15%割引コード支給",
        purchase_amount: "￥10,000,000 以上",
      },
      employee: {
        discount_code: "",
        benefits: "30% - 70% 常時割引",
      },
      policy: {
        "1": "今後のメンバーシップ特典および選定基準は、予告なく変更される場合があります。",
        "2": "会員ランク特典は {{storeName}} オンラインストアでのみ適用可能です。",
        "3": "ランク別割引コード特典として、毎月1日午前11時に1回使用可能なメンバーシップ専用割引コードが発行され、翌月1日午前10時59分まで使用可能です。（マーケティング情報受信の可否およびマーケティングのための個人情報収集・利用を拒否された場合、各種お知らせや特典に制限がある場合があります。）",
        "4": "ランク基準は毎月1日午前11時から順次変更され、変更日から直近3年以内の累積実決済金額を基準に適用されます。",
        "5": "メンバーシップ会員ランクは、総注文金額からキャンセルおよび返金を差し引いた実決済金額を基準に算定されます。実決済金額は割引適用後、送料を除いた純粋な商品金額であり、注文日から7日経過後に加算されます。",
        "6": "割引コードをご使用の場合、1回の注文につき1つのコードのみ使用可能で、他の割引コードとの重複使用はできません。",
        "7": "一部の商品については割引および特典の対象外となります。",
        "8": "会員ランクによる特典は他人に譲渡できません。（不正な方法により累積された実績と疑われる場合、会員ランクが降格されることがあります。）",
        "9": "一部の割引コードはメンバーシップ常時割引との重複適用ができない場合があります。",
        "10": "発行されたコードは使用と同時に消滅し、再発行および復元は不可能です。",
        "11": "発行されたコードは使用と同時に消滅し、再発行および復元はできません。",
      },
      toss_policy: {
        "1": "Toss社員アカウントの注文金額上限は年 ￥2,000,000 であり、毎年1月1日にリセットされます。",
        "2": "累積注文金額とカート金額の合計が注文金額上限を超える場合、注文を進めることができません。カートの商品および金額を調整してご購入ください。",
        "3": "商品の割引率がToss社員割引特典によって適用される割引率より高い場合、商品割引率のみが適用されます。",
        "4": "一部の商品はToss社員割引特典が適用されず、割引特典が適用されない商品を購入した場合でも累積注文金額に含まれます。",
        "5": "Toss社員アカウントは、Toss社員割引特典を除く別途の割引プロモーションが適用されません。",
        "6": "退職時には翌月1日にアカウントが無効化処理されます。無効化された後はログインができませんので、お問い合わせがある場合は右下のチャネルトークをご利用ください。",
      },
    },
    order: {
      none: "注文履歴がありません。",
      return_order: "返品申請",
      unwanted: "自己都合",
      already: "すでに応募済みです。",
    },
    info: {
      me: "マイ情報",
      agree: "以下の情報とあわせてマーケティング情報の受信・活用に同意いただくと、さまざまな会員特典をご利用いただけます。",
      card: "保存されたカード",
      card_save: "よく使うカードをアカウントに保存して管理し、より便利に決済してください。",
      password: "パスワード変更",
      password_info: "個人情報保護のため、1年以上パスワードを変更していない場合はパスワードの変更をお勧めしています。",
      social: "ソーシャルログイン",
      social_current: "現在接続されているソーシャルログインサービスです。",
      delete: "退会",
      delete_request:
        "アカウント削除は要請後3日以内に処理されます。アカウントを削除すると、すべての会員情報および注文履歴が削除され、商品の決済、注文、配送状況の確認などの機能を利用できなくなります。",
      delete_ask: "本当に退会しますか？\n「Okay」ボタンを押すと退会手続きを行います。",
      current_password: "現在のパスワード",
      new_password: "新しいパスワード",
      check_password: "パスワード確認",
      change_password: "パスワードを変更する",
      marketing_agree: "マーケティング情報の受信",
      save_card: "保存されたカードの管理",
      male: "男性",
      female: "女性",
    },
    shipping: {
      address: {
        first_name: "名",
        last_name: "姓",
        zip: "郵便番号",
        city: "都道府県",
        address1: "住所",
      },
    },
    return: {
      select_item: "返品を申請する商品を選択してください。",
      return_reason: "返品理由",
      select_reason: "返品理由を選択してください。",
      channel_talk_notice: "*該当商品の返品についてはチャネルトークからお問い合わせください。",
      unwanted_notice: "自己都合による返品の場合、配送料が課金されることがあります。",
      warn: {
        no_return_product: "返品を申請する商品を選択してください。",
        no_reason: "返品理由を選択してください。",
        remove_product: "返品申請個数は1個以上である必要があります。",
        over_product: "返品可能な最大個数まで選択されました。",
        discount_code_valid: "割引コードを入力してください。",
        quantity_insufficient:
          "注文しようとしている商品の数量が、注文過程で購入可能数量を超えました。カート内の該当商品の数量が購入可能数量に合わせて調整され、品切れの商品は削除されます。",
        invalid_cart: "購入可能な商品がありません。",
        necessary_invalid_shipping_address: "入力された配送先住所が正しくありません。配送先住所が正しいか確認してください。",
        wrong_discount_code: "有効ではない割引コードです。",
        necessary_payment_data: "決済情報がありません。もう一度お試しください。",
        login_password: "現在使用中のパスワードを正確に入力してください。",
        update_new_password: "現在のパスワードと異なるパスワードを入力してください。",
        too_short: "パスワードは5文字以上で入力してください。",
        invalid_credentials: "メールアドレスまたはパスワードが正しくありません。",
        email_account: "メールで登録したアカウントです。メールログインを利用してください。",
        social_account: "{{social}}で登録したアカウントです。{{social}}ログインを利用してください。",
        social_account_taken: "すでに登録されているメールアドレスです。{{social}}ログインを利用してください。",
        password_reset_social_email: "ソーシャルログインアカウントはパスワードの再設定が不可能です。",
        end_session: "セッションが満了しました。再度ログインしてください。",
        no_login: "ログインが必要です。",
        no_cart: "カートに入っている商品がありません。",
      },
      error: {
        failed_return: "返品申請に失敗しました。再度お試しください。",
        failed_no_return_product: "返品可能な商品がありません。",
        discount_code_valid: "有効ではない割引コードです。",
        payment_info: "決済情報がありません。もう一度お試しください。",
        payment_complete: "決済が正常に完了しませんでした。もう一度お試しください。",
        already_delete_account: "すでに退会処理中のアカウントです。",
        server_error: "サーバーでエラーが発生しました。しばらくしてからもう一度お試しください。",
        exceed_qty: "購入可能な数量を超えました。",
      },
    },
    forgot_password: {
      description: "パスワードをお忘れですか？こちらから再設定してください。",
      label: "パスワードをお忘れの方",
    },
    create_account: {
      description: "利用規約およびプライバシーポリシーに同意します。",
      label: "アカウント作成",
    },
    return_requested: {
      estimated_period: "最大7日",
    },
  },
  order_history: {
    description: "注文履歴を一目で確認してください。<br/>注文をクリックすると、配送先や決済情報などの詳細情報を確認できます。",
    empty: "注文履歴がありません。",
  },
  wishlist: {
    description: "お気に入りの商品をウィッシュリストに保存してください。<br/>欲しいアイテムを1か所にまとめて、いつでも確認できます。",
    empty: "ウィッシュリストに保存された商品がありません。",
    none: "ウィッシュリストに保存された商品はありません。",
    delete_ask: "この商品をウィッシュリストから削除しますか？",
  },
  address_book: {
    create_new_address: "新しい住所を追加",
    edit_address: "配送先の修正",
    set_as_default_address: "デフォルトの配送先に設定",
    description: "よく使う配送先を保存して管理してください。<br/>デフォルトの配送先を設定すると、より迅速かつ便利に注文できます。",
    delete_address: "配送先を本当に削除しますか？",
    save: "住所保存",
    save_continue: "住所選択",
    change: "住所変更",
    use_other: "お届け先を変更する",
    default_address: "デフォルトのお届け先",
    in_use: "使用中",
    my_addresses: "お届け先一覧",
    empty: "保存されたお届け先はまだありません。",
    change_address: "別のお届け先を使用する",
    empty_address: "保存されたお届け先がありません。",
  },
  contact: {
    description:
      "ストア利用中にお問い合わせがある場合は、以下の方法でご連絡ください。<br/>注文の変更・キャンセル、配送追跡は次のページで可能です。",
    working_hours: "カスタマーセンター営業時間: 平日 午前9時 - 午後5時",
    other_inquries: "その他のお問い合わせは <email>{{supportEmail}}</email> をご利用ください。",
    cs_info: "※ お電話でのご相談は承っておりません。チャットサポートまたはメールでお問い合わせください。",
    order_history: "注文履歴を見る",
    membership: "過去12ヶ月間のランクポイントに基づいて、毎月1日に新しい会員ランクが決定されます。さまざまな特典をぜひご確認ください。",
    my_membership: "マイランクを確認する",
  },
  checkout: {
    notice: "システム上の問題により、関税および税金が初回のお支払いとは別に請求される場合があります。ご不便をおかけし申し訳ございません。",
    create_shipping_address: "配送先住所を登録して注文を進めてください。",
    description:
      "すべての取引は安全に暗号化されます。<br/>決済情報を保存して、迅速かつ便利に注文してください。一般決済は他の決済手段を選択して利用できます。",
    use_as_billing_address: "請求先住所として使用",
    pay_now: "決済",
    consent: "注文内容をすべて確認し、ストアおよび決済代行サービス（Toss Payments）の利用規約に同意します。",
    discount_code_alert: "* コラボレーションおよび一部のコレクションは割引コード適用の対象外です。",
    discount_code_alert_description:
      "一部のコレクションは割引から除外され、割引コードが適用された注文をキャンセルした場合、割引コードは再発行されません。",
    wrong_customer_id: "顧客情報が一致しません。現在ログインしているアカウントをログアウト後、同じアカウントで再度ログインしてください。",
    wrong_cart_amount: "カートの金額が決済金額と一致しません。",
    wrong_discount_name: "有効ではない割引コードです。",
    wrong_discount_code: "有効ではない割引コードが適用されました。もう一度お試しください。",
    wrong_cart_changed: "商品、数量、または価格が変更されたためカートが更新されました。もう一度お試しください。",
    gifting_description: "大切な方へギフトを贈りましょう。<br/>お支払いが完了すると、LINEでギフトメッセージを送信できます。",
    gifting_card_message: "ギフトメッセージに含める内容をご記入ください。",
    gifting_recipient: "受け取られる方がご自身宛のギフトだとわかるよう、受取人のお名前はできるだけ本名でご入力ください。",
    discount_input: "割引コードを入力してください。",
    discount_code_placeholder: "割引コードを入力してください。",
  },
  cart: {
    discount: "配送料および割引コードは決済段階で適用されます。",
    checkout: "購入する",
    preorder: "予約発送商品は通常の商品と一緒にカートに入れることはできず、現在のカートで単独で購入する必要があります。",
  },
  order_completed: {
    description:
      "ご注文が正常に処理されました。<br/>注文情報は注文履歴ページでご確認いただけます。商品の発送時に通知およびメールでご案内いたします。",
  },
  product: {
    restock_notification: {
      description: "メールアドレスをご登録ください。再入荷時にお知らせします。",
    },
    membership_auto_discount_notice: "メンバーシップ ランク割引の対象外商品です。",
    discount_code_unavailable_notice: "メンバーシップ割引コードをご利用いただけない商品です。",
    pigment_warning: "色落ちや色移りの恐れがありますので、洗濯および着用時にご注意ください。",
    preorder_description:
      "予約発送商品は通常商品と配送スケジュールが異なるため、既存のカートとは別に、この画面から単独でのご購入のみ可能です。",
    pre_order_warning:
      "プレオーダー商品は単独でのみご注文いただけます。<br/>この商品をカートに追加すると、カート内の通常商品は削除されます。",
    normal_items_warning:
      "プレオーダー商品は単独でのみご注文いただけます。<br/>この商品をカートに追加すると、カート内のプレオーダー商品は削除されます。",
    shipping: {
      description:
        "配送方法：宅配（一般配送）<br/>地域：全国地域<br/>期間：営業日2日〜5日<br/>案内：離島・山間部は追加料金が発生する場合があります。<br/><br/>不良・誤配送、広告内容と異なる配送の場合は、3ヶ月以内に受付してください。<br/>配送および返品の詳細については、以下のリンクのページでご確認ください。<information>{{domain}}</information>",
    },
  },
  collection: {
    empty: "申し訳ございません。現在このページに用意された商品がありません。",
    ready: "コレクションの商品を準備中です。",
  },
  return: {
    reason: "理由",
    request: "返品申請",
    request_description: "商品の状態により払い戻し予定金額が変更される場合や、返品申請が拒否される場合があります。",
    detail_reason: "詳細理由",
    description: "返品を申請する商品と理由を選択してください。<br/>返品申請は注文作成後7日以内のみ可能です。",
    requested_description: "返品申請が完了しました。<br/>返品の承認または拒否時にカカオ通知トークでご案内します。",
    view_policy: "配送および返品規定を見る",
    detail_description: "関連する説明を入力してください。",
    additional_description:
      "返品申請する商品と理由をもう一度確認してください。<br/>返品申請の内容が規定に反する場合、申請が拒否されることがあります。",
    image_description: "*商品の不良および誤配送に関連する写真をアップロードしてください。",
    add_image: "関連する写真をアップロードしてください。",
    select_reason: "返品理由を選択してください。",
    unwanted_notice: "自己都合による返品の場合、配送料が課金されることがあります。",
    refund_shipping_notice: "{{reason}}による返品の場合、送料が発生することがあります。",
    disabled_product: "*該当商品の返品についてはチャネルトークからお問い合わせください。",
    upload_image: "写真をアップロードしてください...",
    gift_description: "ノベルティは支給条件に応じて自動的に選択されます。",
    return_reason: {
      unwanted: "自己都合",
      default: "返品理由を選択",
      defective: "商品の不良および誤配送",
      size_large: "サイズが大きい",
      size_small: "サイズが小さい",
      wrong_item: "商品の誤配送",
    },
    reasons: {
      defective: "商品の不良および誤配送",
      unwanted: "自己都合",
    },
    optional: "任意",
  },
  return_requested: {
    description: "返品申請が正常に完了しました。<br/>返品の承認または拒否時にカカオ通知トークでご案内します。",
    estimated_period: "最大7日",
    button: "配送・返品規約を見る",
    additional_charge: "*返品する商品のご購入価格が返品送料を下回る場合、追加の返品送料をご負担いただきます。",
    title: "返品を受け付けました。",
    estimated_refund_amount: "返金予定額",
    return_deadline: "返品期限",
    return_shipping_fee: "返品送料",
  },
  search: {
    empty: "「{{value}}」に対する検索結果がありません。他の検索語でお試しください。",
    view_all: "すべて見る",
    placeholder: "検索語を入力してください。",
    alert: "検索キーワードを入力してください。",
    no_matches: "検索条件に一致する商品はありません。",
  },
  membership: {
    title: "{{storeName}} メンバーシップを通じて、特別割引特典とともに新商品情報やイベント情報をいち早く受け取ってください。",
    higher: "{{currency}}{{amount}} 以上",
    lower: "{{currency}}{{amount}} 未満",
    discount: "常時割引 {{amount}}%",
    discount_rate: "常時割引率",
    coupon: "月間コード {{amount}}%",
    total_spent: "累計ご購入金額",
    left: "次のランクまであと ₩{{amount}} です。",
    total: "現在の累計ご購入金額は ₩{{amount}} です。",
    view_membership: "マイメンバーシップ情報を見る",
    description_text: "ランクに応じた常時割引に加え、メンバーシップ会員限定の各種割引やエクスクルーシブコンテンツをお楽しみください。",
    current_membership: "{{last_name}}{{first_name}}様のランクは <membership>{{membership}}</membership> です。",
    monthly_discount_code: "月間割引コード",
    description: {
      "1": "会員ランクの特典は {{storeName}} オンラインストアでのみご利用いただけます。",
      "2": "ランクは毎月1日に変更月から1年以内の累積金額を基準に適用されます。",
      "3": "累積金額は実決済額を基準とします。ただし、累積決済額は注文規定により、注文日から7日後から合算されます。",
      "4": "一部の商品については割引および特典の対象外となります。",
      "5": "発行されたコードは使用と同時に消滅し、再発行および復元は不可能です。",
      "9": "一部の商品については割引および特典の対象外となります。",
      "11": "発行されたコードは使用と同時に消滅し、再発行および復元は不可能です。",
    },
    policy: {
      "2": "会員ランクの特典は {{storeName}} オンラインストアでのみご利用いただけます。",
      "3": "ランク別の割引コード特典として、毎月1日午前11時に1回のみ使用できるメンバーシップ専用割引コードが発行され、翌月1日午前10時59分までご利用いただけます。（マーケティング情報の受信、およびマーケティング目的の個人情報の収集・利用に同意されない場合、各種お知らせや特典に制限が生じることがあります。）",
      "4": "ランク基準は毎月1日午前11時から順次変更され、変更日から過去1年以内の累計実決済金額をもとに適用されます。",
      "6": "割引コードは1回のご注文につき1つのみ使用でき、他の割引コードとの併用はできません。",
      "7": "一部の商品については割引および特典の対象外となります。",
      "10": "発行されたコードは使用と同時に消滅し、再発行および復元は不可能です。",
      "11": "発行されたコードは使用と同時に消滅し、再発行および復元はできません。",
    },
  },
  success: {
    password_reset_email: "パスワード再設定メールが送信されました。",
    password_reset_social_email: "ソーシャルログインアカウントはパスワードの再設定が不可能です。",
    newsletter_subscribe_message: "メール認証を完了するとニュースレターを購読できます。",
    copy_url: "商品のURLがコピーされました。",
    copy_url_message: "貼り付けて商品のURLを共有してください。",
    modify_account_info: "会員情報の修正が完了しました。",
    verification: "本人確認が完了しました。",
    raffle_entry: "応募が完了しました。",
    payment: "決済が正常に処理されました。",
    newsletter_subscribe: "ニュースレター購読確認メールが送信されました。",
    login: "ログインしました。",
    restock: "再入荷通知の登録が完了しました。",
    wishlist_add: "ウィッシュリストへの追加が完了しました。",
    wishlist_remove: "ウィッシュリストからの削除が完了しました。",
    address_remove: "住所の削除が完了しました。",
    logout: "ログアウトしました。",
    cancel_order: "注文のキャンセルが完了しました。",
    validate_toss: "Toss社員の確認が完了しました。",
    adult_verification: "年齢確認が完了しました。",
    password_change: "パスワードが変更されました。 再度ログインしてください。",
    register_complete: "会員登録が完了しました。",
  },
  warning: {
    login: "メールアドレスまたはパスワードが正しくありません。",
    phone: "正しい電話番号の形式で入力してください。",
    phone_taken: "すでに登録されている電話番号です。",
    add_cart: "購入可能な数量を超えました。",
    payment_cancel: "進行中の決済がキャンセルされました。決済を完了するには再度お試しください。",
    quantity_limit: "購入可能な数量を超えました。",
    quantity_insufficient:
      "注文しようとしている商品の数量が、注文過程で購入可能数量を超えました。カート内の該当商品の数量が購入可能数量に合わせて調整され、品切れの商品は削除されます。",
    necessary_shipping_address: "商品を受け取る配送先を入力してください。",
    necessary_invalid_shipping_address: "入力された配送先住所が正しくありません。配送先住所が正しいか確認してください。",
    necessary_payment_data: "決済情報がありません。もう一度お試しください。",
    necessary_payment_method: "決済手段を選択してください。",
    no_return_for_gift: "サ恩品のみの返品はできません。",
    no_return_product: "返品を申請する商品を選択してください。",
    no_reason: "返品理由を選択してください。",
    no_returnable_product: "注文履歴に現在返品不可能な商品があります。該当商品はカスタマーセンターにお問い合わせください。",
    no_quantity_product: "返品申請できない商品です。",
    same_account_info: "既存の顧客情報と異なる値を入力してください。",
    invalid_cart: "購入可能な商品がありません。",
    reusable_bag_limit: "Reusable Carrier Bagは単独で購入できません。",
    end_session: "セッションが満了しました。再度ログインしてください。",
    fail_calculate_order: "注文金額の計算に失敗しました。もう一度お試しください。",
    already_restock: "すでに再入荷通知が申請されている電話番号です。",
    gifting_necessary_receiver_name: "受取人のお名前を入力してください。",
    gifting_necessary_sender_phone: "お客様情報ページ（<a>{{storeDomain}}/account</a>）で電話番号を保存してから、もう一度お試しください。",
    gifting_necessary_message_content: "ギフトメッセージを入力してください。",
    no_login: "ログインが必要です。",
    no_cart: "カートに入っている商品がありません。",
    remove_product: "返品申請個数は1個以上である必要があります。",
    over_product: "返品可能な最大個数まで選択されました。",
    not_match_password: "現在使用中のパスワードを正確に入力してください。",
    same_password: "現在のパスワードと異なるパスワードを入力してください。",
    no_detail_reason: "返品の詳細理由を入力してください。",
    no_image: "返品理由に関連する写真をアップロードしてください。",
    social_account: "{{social}}で登録したアカウントです。{{social}}ログインを利用してください。",
    no_email: "登録されていないメールアドレスです。",
    checkout_shipping_address_blocked: "選択された住所は利用規約により配送できない住所です。別の住所をご利用ください。",
    exceed_purchase_limit: "累計注文金額とカート金額の合計が注文金額上限を超えました。カートの商品および金額を調整してください。",
    remaining_limit: "最大注文可能金額: ₩{{amount}}",
    adult_only: "*成人のみ",
    separate_required:
      "カートに年齢確認が必要な商品が含まれています。<br/>この商品は通常商品と一緒にお支払いいただけないため、通常商品とは分けてご注文ください。",
    request_identity_verification: "カートに年齢確認が必要な商品が含まれています。<br/>本人確認のうえ、ご注文にお進みください。",
    need_identity_verification: "本人確認がキャンセルされました。商品をご購入いただくには、もう一度お試しください。",
    fail_identity_verification: "本人確認に失敗しました。もう一度お試しください。",
    empty_cart: "カートに商品がないため、前のページに戻ります。",
    necessary_billing_address: "請求先住所を入力してください。",
    no_quantity_cart: "こちらの商品は在庫切れのため、カートに追加できません。",
    newsletter_empty_email_title: "メールアドレスを入力してください。",
  },
  error: {
    already_used_discount_code: "すでに使用された割引コードです。",
    failed_api_discount_code: "割引コードの使用に失敗しました。しばらくしてからもう一度お試しください。",
    not_found: "存在しないURLです。",
    payment: "決済が正常に完了しませんでした。もう一度お試しください。",
    necessary_country: "国を入力してください。",
    necessary_lastName: "姓を入力してください。",
    necessary_firstName: "名を入力してください。",
    necessary_city: "都市を入力してください。",
    necessary_zip: "郵便番号を入力してください。",
    necessary_province: "都道府県を入力してください。",
    necessary_address1: "住所を入力してください。",
    necessary_address2: "住所（詳細）を入力してください。",
    necessary_phone: "電話番号を入力してください。",
    necessary_english: "英語、数字、特殊文字のみで入力してください。",
    invalid_phone: "電話番号を正確に入力してください。",
    invalid_birthday: "生年月日を形式に合わせて入力してください (例: MM/DD/YYYY)。",
    necessary_password: "パスワードを入力してください。",
    necessary_new_password: "変更するパスワードを入力してください。",
    necessary_confirm_password: "変更するパスワードをもう一度入力してください。",
    necessary_email: "メールアドレスを入力してください。",
    match_password: "パスワードが一致しません。再度ご確認ください。",
    necessary_consent: "個人情報の収集および利用に同意してください。",
    failed_no_return_product: "返品可能な商品がありません。",
    exceed_qty: "購入可能な数量を超えました。",
    already_delete_account: "すでに退会処理中のアカウントです。",
    verification_error_description: "本人確認の処理中にエラーが発生しました。",
    verification_error_failure: "認証に失敗しました。もう一度お試しください。",
    verification_none: "認証されていないアカウントです。<br/>初回に1度、本人確認を行ってください。",
    raffle_already_entered: "すでに応募済みの商品です。",
    raffle_error: "応募の処理中にエラーが発生しました。",
    blocked_address: "選択された住所は利用規約により配送できない住所です。別の住所をご利用ください。",
    gifting_fetch_failed: "ギフト情報の読み込み中にエラーが発生しました。",
    gifting_accept_failed: "ギフトの受け取り処理中にエラーが発生しました。もう一度お試しください。",
    gifting_share_data: "ギフト送信に必要なデータの読み込み中にエラーが発生しました。もう一度お試しください。",
    server: "サーバーでエラーが発生しました。しばらくしてからもう一度お試しください。",
    search: "検索語を入力してください。",
    select_option: "オプションを選択してください。",
    discount_code: "有効ではない割引コードです。",
    cancel_order: "注文のキャンセルが処理されませんでした. しばらくしてからもう一度お試しください。",
    checkout: "決済ページでエラーが発生しました。しばらくしてからもう一度お試しください。",
    invalid_phone_number: "電話番号を正確に入力してください。",
    invalid_english: "英字で入力してください。",
    invalid_zip: "郵便番号を正確に入力してください。",
    necessary_field: "必須入力項目です。",
    toss_payment: "決済サービスでエラーが発生しました。もう一度お試しください。",
    server_title: "サーバーでエラーが発生しました。しばらくしてからもう一度お試しください。",
    discount_code_title: "有効ではない割引コードです。",
    already_used_discount_code_title: "すでに使用された割引コードです。",
  },
  login: {
    invalid_email: "有効なメールアドレスを入力してください。",
    in_app_browser: "お知らせ",
    in_app_browser_message:
      "現在使用中のブラウザではソーシャルログインを使用できません。<br/>メールログインまたは他のブラウザをご利用ください。",
    account_disable:
      "当該アカウントは退会申請を受け付けており、現在ログインおよびサービスのご利用は制限されています。<br/>会員アカウントおよび個人情報は、最終注文日から最短1日～最長30日経過後に自動的に削除されます。削除完了までは、同じメールアドレスでの再登録はできません。<br/>ストアをご利用される場合は、別のメールアドレスで新規会員登録のうえご利用ください。",
    min_password: "パスワードは5文字以上で入力してください。",
    social: "ソーシャル",
    kakao_continue: "Kakao で続ける",
    google_continue: "Google で続ける",
    social_continue: "ソーシャルログインで続ける",
    email_continue: "メールで続ける",
    reset_password: "パスワードの再設定",
    register: "会員登録",
    cancel: "キャンセル",
    login: "ログイン",
    send_email: "メールを送信",
    connect: "アカウントと連携されています。",
    apply: "適用する",
    info: "メールアドレスとパスワードを設定して会員登録いただくと、お支払い、注文確認、配送状況の確認、ランク別特典など、より便利にストアをご利用いただけます。",
    personal_info: "プライバシーポリシーおよび利用規約に同意する（必須）",
    marketing_subscribe: "マーケティング情報の受信に同意する（任意）",
    auth: "本人確認を行う",
    auth_ask: "より安全なお取引のため、\n初回に1度、本人確認を行ってください。",
    verificaton_error: "認証に失敗しました。",
    social_login_reset_password:
      "メールでパスワード再設定用のリンクをお送りします。\n新しいパスワードに変更後、あらためてソーシャルログインをお試しください。",
    description:
      "{{storeName}} オンラインストアの会員になりませんか。<br /> 毎月のメンバーシップ特典に加え、お支払い、注文履歴の確認、配送状況の確認など、より便利にご利用いただけます。",
  },
  footer: {
    company1: "JKND株式会社",
    company2: "事業者登録番号 361-86-01005",
    company3: "代表 ジョナサン",
    company4: "ソウル特別市城東区アチャサン路159（聖水洞2街、JKND）",
    company5: "070-4048-5375",
    company6: "通信販売業申告 2024-ソウル城東-1504",
  },
  information: {
    email: "cs_jp@thisisneverthat.com",
    channel_talk: "thisisneverthat.channel.io",
    info1: "ストア利用中にお問い合わせがある場合は、以下の方法でお問い合わせください。",
    shipping: {
      method: "配送業者",
      method_description: "ヤマト運輸・佐川急便",
      zone: "送料",
      zone_description:
        "国内一律660円（税込)<br/>※沖縄•北海道及び離島、一部の地域は一律1,100円（税込<br/>※合計金額が15,400円（税込）以上で送料無料<br/>（沖縄•北海道及び離島、一部の地域対象外）",
      time: "",
      time_description: "",
      description: "※天候、交通事情、地域等の理由で商品の到着が遅れる場合がございます。ご了承下さい。",
      rate: "商品のお届け時期",
      rate_description: "注文確定後、５営業日以内に発送致します",
    },
  },
  news_letter: {
    accepts_marketing: "マーケティング活用および広告メールの受信同意",
  },
  modal: {
    cancel_order: {
      description: "注文をキャンセルしますか？<br/>決済された金額は営業日から最大3〜5日以内に払い戻されます。",
    },
  },
  return_reason: {
    wrong_item: "商品の誤配送",
    defective: "商品の不良",
    size_large: "サイズが大きい",
    size_small: "サイズが小さい",
    unwanted: "自己都合",
    default: "その他",
  },
  loading: {
    payment: {
      title: "決済が進行中です。",
      description: "ページを更新したり閉じたりすると、<br/>進行中の決済がキャンセルされる場合があります。",
    },
  },
  toast: {
    account: {
      success: {
        register: "会員登録が完了しました。",
        login: "ログインしました。",
        logout: "ログアウトしました。",
        disable_customer: "会員退会が完了しました。",
      },
    },
  },
  deactivate_account: "退会が完了しました。",
  toss_policy: {
    "1": "Toss 社員アカウントのご注文金額の上限は年間 ₩2,000,000 で、毎年1月1日にリセットされます。",
    "2": "累計注文金額とカート内金額の合計がご注文金額の上限を超える場合、ご注文いただけません。カート内の商品および金額を調整のうえご購入ください。",
    "3": "商品の割引率が Toss 社員割引の割引率を上回る場合は、商品の割引率のみが適用されます。",
    "4": "一部の商品は Toss 社員割引の対象外です。対象外の商品をご購入の場合も、累計注文金額には含まれます。",
    "5": "Toss 社員アカウントには、Toss 社員割引を除く別途の割引プロモーションは適用されません。",
    "6": "退職された場合、翌月1日にアカウントが無効化されます。無効化後はログインできないため、お問い合わせは右下のチャットをご利用ください。",
  },
};

export default jp;
